<template>
    <SignaloDialog
        :title="$t('equipmentTypes.newEquipmentType')"
        :icon="'mdi-cog-outline'" 
        :open="open"
        @close="closeDialog"
        :constHeight="false"
    >
        <template #body>
            <v-card-text>
                <v-form ref="dataForm" v-model="dataValid" lazy-validation>
                    <v-text-field
                        v-model="name"
                        :counter="250"
                        :rules="nameRules"
                        :label="$t('common.name')"
                        required
                        variant="outlined"
                        color="var(--greyscale-100)"
                        class="required-field"
                    >
                    </v-text-field>

                    <SignaloDictionaryTreePicker
                        :group="dictionaryTreePickerGroup"
                        v-model="group"
                        v-slot="props"
                        ref="dictionaryTreePicker"
                    >
                        <v-text-field
                            :modelValue="props.text"
                            @click:control="props.onClick"
                            @click:clear="props.onClear"
                            clearable
                            readonly
                            hide-details
                            :label="$t('common.group')"
                            clear-icon="mdi-close-circle-outline"
                            variant="outlined"
                            color="var(--greyscale-100)"
                        />
                    </SignaloDictionaryTreePicker>
                </v-form>
            </v-card-text>
        </template>
        <template #buttons>
            <v-btn @click="closeDialog(false)">{{ $t('common.cancel') }}</v-btn>
            <v-btn
                color="primary"
                variant="elevated"
                @click="saveData"
                :loading="saveLoading"
            >
                {{ $t('common.save') }}
            </v-btn>
        </template>
    </SignaloDialog>
</template>

<script>
import * as HELPERS_STORE from 'signalo-vue-helpers-store';
export default {
    $emits: ['close'],
    props: ['open', 'item', 'equipmentKind'],
    setup() {
        const helpersStore = HELPERS_STORE.default();
        return { helpersStore };
    },
    data() {
        return {
            saveLoading: false,
            name: this.item?.name || '',
            type: this.equipmentKind || this.item?.type || 'machine',
            group: this.item?.item_group || null,

            // DATA
            dataValid: true,
            dataSaving: false,
            currentType: this.equipmentKind || 'machine',
        };
    },
    computed: {
        dictionaryTreePickerGroup: function () {
            return this.equipmentKind === 'machine'
                ? 'machine_groups'
                : 'tool_groups';
        },
    },
    methods: {
        closeDialog(shouldRefetchData = false, newEquipmentType = null) {
            this.$emit('close', shouldRefetchData, newEquipmentType);
        },
        async saveData() {
            await this.$refs.dataForm.validate();
            if (this.dataValid) {
                this.dataSaving = true;
                const data = {
                    name: this.name,
                    type: this.type,
                    item_group: this.group,
                };
                if (this.item?.id) {
                    this.axios
                        .request({
                            url: `/equipment_types/${this.item.id}`,
                            method: 'PUT',
                            data,
                        })
                        .then((res) => {
                            this.helpersStore.snackbarSaved();
                            this.closeDialog(true, res?.data?.item);
                        })
                        .catch((e) => {
                            if (e.response?.status == 401) return;
                        })
                        .finally(() => {
                            this.dataSaving = false;
                        });
                } else {
                    this.axios
                        .request({
                            url: `/equipment_types`,
                            method: 'POST',
                            data,
                        })
                        .then((res) => {
                            this.helpersStore.snackbarSaved();
                            this.closeDialog(true, res?.data?.item);
                        })
                        .catch((e) => {
                            if (e.response?.status == 401) return;
                        })
                        .finally(() => {
                            this.dataSaving = false;
                        });
                }
            }
        },
    },
};
</script>
